<template>
  <form class="file-drop-zone" ref="fileForm">
    <div v-if="quotation != null">
      <div v-if="quotation.files.length == 0" class="upload-text">
        <svg
          viewBox="0 0 1024 1024"
          class
          data-icon="inbox"
          width="35px"
          height="35px"
          fill="#40a9ff"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
          />
        </svg>
        <span style="font-size: 18px">
          Drop
          <strong>{{ fileTags[0] }}</strong> file(s) to be uploaded here (in PDF format
          only)
        </span>
      </div>
      <div v-else style="display: table; width: 100%">
        <template v-for="(item, i) in quotation.files">
          <div :key="i" class="file-item-row">
            <div>
              <span>
                <b>{{ item.file_tags }}</b>
                : {{ item.file_name }}
              </span>
            </div>
            <div>
              <v-icon small @click="onFileDelete(item)">fa-times</v-icon>
            </div>
          </div>
        </template>
      </div>
    </div>
  </form>
</template>

<script>
import constant from "../../const";

export default {
  props: ["value", "fileTags"],

  data() {
    return {
      quotation: this.value || null,
    };
  },

  watch: {
    value: function () {
      this.quotation = this.value;
    },
  },

  mounted() {
    [
      "drag",
      "dragstart",
      "dragend",
      "dragover",
      "dragenter",
      "dragleave",
      "drop",
    ].forEach(
      function (evt) {
        /*
                For each event add an event listener that prevents the default action
                (opening the file in the browser) and stop the propagation of the event (so
                no other elements open the file in the browser)
            */
        this.$refs.fileForm.addEventListener(
          evt,
          function (e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    /*
        Add an event listener for drop to the form
        */
    this.$refs.fileForm.addEventListener(
      "drop",
      function (e) {
        /**
         * Capture the quotation from the drop event and add them to our local quotation
         * array.
         */
        var response = null;
        this.$root.blockUImsg = "Uploading quotation file...";
        this.$root.blockUIshow = true;
        let totalFiles = e.dataTransfer.files.length;

        // instantiate formData
        let formData = new FormData();

        // append the files
        for (let i = 0; i < totalFiles; i++) {
          formData.append("files", e.dataTransfer.files[i]);
        }

        formData.append("category", "quotations");
        formData.append("company_id", this.quotation.company_id);
        formData.append("file_tags", this.fileTags[0]);

        this.$https
          .post(`/api/files/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: this.$root.access_token,
            },
          })
          .then((resp) => (response = resp.data))
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            // console.log(response);
            if (response.status == constant.RESPONSE_STATUS_OK) {
              this.quotation.files.push(...response.data);
            } else {
              console.log("Error uploading files", response);
            }

            this.$root.blockUIshow = false;
          });

        this.emitFileUpdate();
      }.bind(this)
    );

    this.$refs.fileForm.addEventListener("dragenter", function (e) {}.bind(this));
  },

  methods: {
    onFileDelete(file) {
      this.quotation.files = this.quotation.files.filter(function (ele) {
        return ele != file;
      });
    },

    emitFileUpdate() {
      this.$emit("input", this.quotation);
    },
  },
};
</script>

<style></style>
